import {isFeatureEnabled} from '@github-ui/feature-flags'
import {constructSharedWorker, constructWorker} from '@github-ui/trusted-types/worker'

export function createWorker(url: string, options?: WorkerOptions): Worker {
  if (!isFeatureEnabled('trusted_types_worker')) return new Worker(url, options)
  return constructWorker(url, options)
}

export function createSharedWorker(url: string, options?: string | WorkerOptions): SharedWorker {
  if (!isFeatureEnabled('trusted_types_worker')) return new SharedWorker(url, options)
  return constructSharedWorker(url, options)
}
